import pageContext from 'salvo-lite/context'

import ToggleSearch from './components/ToggleSearch'
import Preload from './components/Preload'
import AjaxCart from './components/AjaxCart'
import StickyElem from './components/StickyElem'
import Product from './components/Product'
import ToggleClasses from './components/ToggleClasses'
import Slider from './components/Slider'
import Accordion from './components/Accordion'
import Navigation from './components/Navigation'
import Cart from './components/Cart'
import SlidingMenu from './components/SlidingMenu'
import LoadMore from './components/LoadMore'
import SelectURL from './components/SelectURL'
import Header from './components/Header'
import Reveal from './components/Reveal'
import ModifyComponent from './components/ModifyComponent'
import PopoutCart from './components/PopoutCart'
import CountryProvinceSelector from './components/CountryProvinceSelector'
import EmptyElemChecker from './components/EmptyElemChecker'
import SortElements from './components/SortElements'
import PlusMinusInput from './components/PlusMinusInput'
import ScrollBar from './components/ScrollBar'
import RecentlyViewed from './components/RecentlyViewed'
import VideoContainer from './components/VideoContainer'
import ViewSwitcher from './components/ViewSwitcher'
import CollectionFilters from './components/CollectionFilters'
import SelectAjaxReplace from './components/SelectAjaxReplace'
import InputHelper from './components/InputHelper'
import CustomerFieldsForm from './components/CustomerFieldsForm'
import CallMethodOnElem from './components/CallMethodOnElem'
import StoreLocator from './components/StoreLocator'
import NewsletterPopup from './components/NewsletterPopup'
import DiscountForm from './components/DiscountForm'
import GiftMessage from './components/GiftMessage'

// PAGES
import ProductPage from './pages/Product'

const components = {
    'input-helper': InputHelper,
    'slider': Slider,
    'toggle-search': ToggleSearch,
    'preloader': Preload,
    'ajax-cart': AjaxCart,
    'sticky': StickyElem,
    'product': Product,
    'toggle-classes': ToggleClasses,
    'accordion': Accordion,
    'navigation': Navigation,
    'cart': Cart,
    'sliding-menu': SlidingMenu,
    'load-more': LoadMore,
    'select-url': SelectURL,
    'header': Header,
    'reveal': Reveal,
    'modify-component': ModifyComponent,
    'popout-cart': PopoutCart,
    'country-province-selector': CountryProvinceSelector,
    'empty-elem-checker': EmptyElemChecker,
    'sort-elements': SortElements,
    'plus-minus-input': PlusMinusInput,
    'scrollbar': ScrollBar,
    'recently-viewed': RecentlyViewed,
    'video-container': VideoContainer,
    'view-switchers': ViewSwitcher,
    'collection-filters': CollectionFilters,
    'select-ajax-replace': SelectAjaxReplace,
    'customer-fields-form': CustomerFieldsForm,
    'call-method-on-elem': CallMethodOnElem,
    'store-locator': StoreLocator,
    'newsletter-popup': NewsletterPopup,
    'discount-form': DiscountForm,
    'gift-message': GiftMessage
}

const pages = {
    'product': ProductPage
}

class Theme {
    constructor () {
        this._components = []
        this._componentsById = {}

        if (document.querySelector('[data-theme-locale]')) {
            this.locale = JSON.parse(document.querySelector('[data-theme-locale]').innerHTML)
        } else {
            this.locale = {}
        }

        if (document.querySelector('[data-shop-info]')) {
            this.shopInfo = JSON.parse(document.querySelector('[data-shop-info]').innerHTML)
        } else {
            this.shopInfo = {
                currency: 'GBP',
                moneyFormat: '£{{amount}}'
            }
        }
    }

    registerComponents (registerContainer = document) {
        for (let key in components) {
            var ComponentConstructor = components[key]
            var elements = registerContainer.querySelectorAll(`.js-component__${key}, [data-${key}]`)
            for (let elem of elements) {
                var instance = new ComponentConstructor(this, elem)
                this._components.push(instance)
                var id = elem.dataset.componentId
                if (id) {
                    this._componentsById[id] = instance
                }
                instance.onInit()
            }
        }
        window.ThemeComponents = this._components
        window.ThemeComponentsId = this._componentsById
        window.__Theme = this
    }

    registerPages () {
        var context = pageContext.getTemplate()
        for (let page in pages) {
            if (page === context) {
                var instance = new pages[page](this)
                instance.onInit()
            }
        }
    }

    getComponents () {
        return this._components
    }

    getComponentsById (id) {
        return this._componentsById[id]
    }

    getComponentsByType (componentConst, includeSubclasses = true) {
        var r = []
        for (let c of this._components) {
            if (includeSubclasses && c instanceof componentConst) {
                r.push(c)
            } else if (c.constructor === componentConst) {
                r.push(c)
            }
        }
        return r
    }
}

export default Theme



// WEBPACK FOOTER //
// ./src/resources/scripts/Theme.js